import { gql } from '@apollo/client'

export const connectInstagram = gql`
  mutation ConnectInstagram($code: String!, $callback: String!) {
    connectInstagram(code: $code, callback: $callback)
  }
`
